import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Curriculum } from 'src/app/courseManagementClasses/curriculum';
import { CurriculumService } from 'src/app/service/curriculum.service';
import { environment } from 'src/environments/environment';
import { SharedDataService } from 'src/app/services/sharedData.service';
import { GlobalClass } from 'src/app/global/global-class';

@Component({ 
  selector: 'app-update-main-curr',
  templateUrl: './update-main-curr.component.html',
  styleUrls: ['./update-main-curr.component.scss']
})
export class UpdateMainCurrComponent implements OnInit { 

  constructor(private currService : CurriculumService,
              public activeModal: NgbActiveModal,
              public bsModalRef: BsModalRef,
              private sharedDataService : SharedDataService,
              private toaster: ToastrService ) { }
              loggedInUser: any;
              theme: any;
  curriculum : Curriculum = new Curriculum();
  subId!: string;
  curId!: string;
clicked = false;
  @Input() fromParent: any; 

  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    this.curId = this.fromParent.curId;
    this.currService.getCurrById(this.curId).subscribe(
      data=>{
        this.curriculum = data;
      });

      this.loggedInUser = JSON.parse(this.sharedDataService.getLoggedInUserDtls());
      this.theme = this.sharedDataService.getCardOfficeTheme();
  }
  getColor(){
    this.sharedDataService.setfooterColor(this.loggedInUser.offices[0].theme);
    return this.loggedInUser.offices[0].theme + '!important';
  }
  onSubmit(){
     //authorized
    this.currService.updateCurriculum(environment.apiUrl + 'curriculum/update',this.curriculum).then(
      data=>{
        this.passEntry.emit(this.curriculum.curId);
        this.activeModal.close();
        this.toaster.success("Curriculum Updated Successfully");
      });
  }
  get backgroundStyle(){
    let globalClass : GlobalClass = new GlobalClass() ;
    return globalClass.backgroundStyle(this.loggedInUser.offices[0].theme);
  }
  closeUpdateModal(){
    this.activeModal.close();
  }

}
